// Module
var code = `<ng-form name="\$ctrl.form">
  <validator condition="\$ctrl.hasValidAddresses()"></validator>
  <div class="form-column" ng-repeat="addr in \$ctrl.addresses">
    <form-section form-title="'Address ' + (\$index + 1) + ''">
      <form-section-field field-title="'Type'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'address', 'type')">
        <select ng-model="addr.type"
                ng-disabled="!\$ctrl.editMode"
                ng-required="\$ctrl.cfg.required(\$ctrl.module, 'address', 'type')"
                ng-options="addressType | prettyEnum for addressType in \$ctrl.addressTypes">
        </select>
      </form-section-field>
      <form-section-field field-title="'Years of stay'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'address', 'years_of_stay')">
        <glue-container append="'Year'"

                        ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'address', 'years_of_stay')">
          <input ng-model="addr.yearsOfStay"
                 ng-disabled="!\$ctrl.editMode"
                 ng-required="\$ctrl.cfg.required(\$ctrl.module, 'address', 'years_of_stay')"
                 type="number"
                 min="0"
                 max="130">
        </glue-container>
      </form-section-field>
      <form-section-field field-title="'Ownership'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'address', 'ownership')">
        <select ng-model="addr.ownership"
                ng-change="\$ctrl.ownershipChanged(addr)"
                ng-disabled="!\$ctrl.editMode"
                ng-required="\$ctrl.cfg.required(\$ctrl.module, 'address', 'ownership')"
                ng-options="ownershipType | prettyEnum for ownershipType in \$ctrl.ownershipTypes">
        </select>
      </form-section-field>
      <form-section-field field-title="'With rent contract'" ng-if="addr.ownership == 'RENTED' && \$ctrl.cfg.visible(\$ctrl.module, 'address', 'rent_contract')">
        <select ng-model="addr.rentContract"
                ng-disabled="!\$ctrl.editMode"
                ng-required="\$ctrl.cfg.required(\$ctrl.module, 'address', 'rent_contract')"
                boolean-options>
        </select>
      </form-section-field>
      <form-section-field field-title="'Rent amount'" ng-if="addr.ownership == 'RENTED' && \$ctrl.cfg.visible(\$ctrl.module, 'address', 'rent_amount')">
        <cash ng-required="\$ctrl.cfg.required(\$ctrl.module, 'address', 'rentAmount')"
              ng-model="addr.rentAmount"
              ng-disabled="!\$ctrl.editMode"></cash>
      </form-section-field>

      <address ng-model='addr' edit-mode="\$ctrl.editMode" module="\$ctrl.module" section="'address'"></address>
      <form-section-field field-title="'Primary'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'address', 'primary')">
        <select ng-model="addr.primary"
                ng-class="{'non-valid-primary-address': !\$ctrl.hasOnePrimaryAddress()}"
                ng-disabled="!\$ctrl.editMode"
                ng-required="\$ctrl.cfg.required(\$ctrl.module, 'address', 'primary')"
                ng-change="\$ctrl.primaryChanged(addr, \$index)"
                boolean-options>
        </select>
      </form-section-field>
    </form-section>

    <div ng-show="\$ctrl.editMode">
      <button type="button" class="btn btn-danger btn--align-with-form-field "
              ng-click="\$ctrl.removeAddress(addr)">
        Remove address
      </button>
    </div>

  </div>

  <div class="form-column" ng-show="\$ctrl.editMode">
    <form-section form-title="'Add new address'">
      <button type="button" class="btn btn-primary btn--align-with-form-field" ng-click="\$ctrl.addAddress()">
        Add new address
      </button>
    </form-section>
  </div>

  <!-- address count validation -->
  <div ng-if="\$ctrl.addresses.length < \$ctrl.minAddressSections">
    <input class="hidden-element" disabled ng-required="true" ng-model="nonExistingValue"/>
  </div>

</ng-form>

<div class="clearfix"></div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/customer-profile-addresses.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;